import { render, staticRenderFns } from "./FlowRecord.vue?vue&type=template&id=05da3eca&scoped=true"
import script from "./FlowRecord.vue?vue&type=script&lang=js"
export * from "./FlowRecord.vue?vue&type=script&lang=js"
import style0 from "./FlowRecord.vue?vue&type=style&index=0&id=05da3eca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05da3eca",
  null
  
)

export default component.exports